<script lang="ts">
    import ClickAction from '~/components/jet/action/ClickAction.svelte';
    import Chevron from '@amp/web-app-components/assets/icons/chevron.svg';
    import type { CreditItem } from '~/jet/models';

    export let infoItems: CreditItem[] = [];
</script>

<div class="credits-list-container" data-testid="credits">
    {#if infoItems?.length}
        <ul class="credits-list" data-testid="credits-list">
            {#each infoItems as item}
                {#if item}
                    <li class="credits-list__item">
                        <div class="credits-list__title">{item.title}</div>
                        <div class="credits-list__subtitle">
                            {#if item.segue}
                                <ClickAction action={item.segue}>
                                    <span class="credits-list__subtitle-link">
                                        {item.subtitle}<Chevron
                                            aria-hidden="true"
                                        />
                                    </span>
                                </ClickAction>
                            {:else}
                                {item.subtitle}
                            {/if}
                        </div>
                    </li>
                {/if}
            {/each}
        </ul>
    {/if}
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/app/core/globalvars' as *;
    @use 'ac-sasskit/core/locale' as *;

    $grid-vertical-spacing: 13px;
    $grid-column-gutter: 20px;
    $grid-row-gutter: 22px;

    .credits-list-container {
        padding-top: $grid-vertical-spacing;
        padding-bottom: $grid-vertical-spacing;
    }

    .credits-list {
        display: grid;
        grid-template-columns: var(--credits-list-grid-cols, repeat(1, 1fr));
        gap: $grid-row-gutter $grid-column-gutter;
        padding-inline: var(--credits-list-padding, 10px);
        word-break: break-word; // Prevent extra long strings from overflowing grid area
    }

    .credits-list__title {
        text-transform: uppercase;
        font: var(--footnote-emphasized);
        color: var(--credits-title-color, var(--systemSecondary));
    }

    .credits-list__subtitle {
        margin-top: 2px;
        font: var(--body);
        color: var(--credits-subtitle-color, var(--systemPrimary));
        text-wrap: pretty;
    }

    .credits-list__subtitle-link :global(svg) {
        width: 10px;
        height: 10px;
        fill: var(--credits-chevron-color, var(--systemPrimary));
        margin-inline-start: 2px;

        @include rtl {
            transform: rotate(180deg);
        }
    }
</style>
